// Only explicit venue-provided labels qualify. Never infer dietary suitability
// or the absence of an allergen from a product name or its modifier choices.
const labels={vegan:'Vegan',vegetarian:'Vegetarian',glutenfree:'Gluten-free',dairyfree:'Dairy-free',halal:'Halal',kosher:'Kosher',pescatarian:'Pescatarian'};
export function dietaryLabels(product) {
  return [...new Set((product.labels||[]).map(value=>labels[String(value).toLowerCase().replace(/[\s-]/g,'')]).filter(Boolean))];
}
